import { CalendarDots as CalendarClock, Gift, ShoppingBag, Storefront as Store, Truck } from '@phosphor-icons/react/dist/ssr';
import type { Icon as IconComponent } from '@phosphor-icons/react';

export interface ServiceItem { icon: IconComponent; label: string; value: string }

/** Only items that really exist for this store. */
export function buildServices(p: {
  sym: string; delivery: boolean; pickup: boolean; fee?: number; freeOver?: number | null; requireSlot?: boolean; min?: number | null;
}): ServiceItem[] {
  const out: ServiceItem[] = [];
  if (p.delivery && p.fee !== undefined) out.push({ icon: Truck, label: 'Delivery fee', value: p.fee > 0 ? `${p.sym}${p.fee.toFixed(2)}` : 'Free' });
  if (p.delivery && p.freeOver) out.push({ icon: Gift, label: 'Free delivery over', value: `${p.sym}${p.freeOver.toFixed(2)}` });
  if (p.pickup) out.push({ icon: Store, label: 'Pickup', value: 'Collect in store' });
  if (p.requireSlot) out.push({ icon: CalendarClock, label: 'Slots', value: 'Book a time at checkout' });
  if (p.min) out.push({ icon: ShoppingBag, label: 'Minimum basket', value: `${p.sym}${p.min.toFixed(2)}` });
  return out;
}

export function ServiceStrip({ items }: { items: ServiceItem[] }) {
  if (!items.length) return null;
  return (
    <section aria-label="Delivery and pickup" className="gh-wrap" style={{ marginTop: 20 }}>
      <ul className="gh-strip">
        {items.map(({ icon: Icon, label, value }) => (
          <li key={label}>
            <Icon size={20} aria-hidden style={{ color: 'var(--color-primary)', flexShrink: 0 }} />
            <span><span className="gh-strip-label">{label}</span><strong>{value}</strong></span>
          </li>
        ))}
      </ul>
    </section>
  );
}
